import type { Translations } from './types';

export const sw: Translations = {
  appName: 'Mwalimu wa Herufi za NATO',
  converter: 'Kibadilishi',
  quiz: 'Jaribio la Herufi',
  wordQuiz: 'Jaribio la Maneno',
  settings: 'Mipangilio',
  enterText: 'Ingiza maandishi ya kubadilisha',
  placeholder: 'Andika ujumbe wako hapa...',
  natoAlphabet: 'Herufi za NATO',
  playPronunciation: 'Cheza Matamshi',
  stop: 'Simama',
  quickReference: 'Marejeleo ya Haraka',
  showLess: 'Onyesha Kidogo',
  viewFullAlphabet: 'Ona Herufi Kamili →',
  copied: 'Imenakiliwa!',
  copyFailed: 'Kunakili kumeshindwa',
  speechNotAvailable: 'Sauti ya bandia haipatikani',
  voiceSettings: 'Mipangilio ya Sauti',
  textToSpeechVoice: 'Sauti ya Maandishi hadi Hotuba',
  testVoice: 'Jaribu Sauti',
  notifications: 'Arifa',
  spacedRepetitionReminders: 'Vikumbusho vya Rudia kwa Nafasi',
  notificationDescription: 'Pata arifa za kila siku ili ufanye mazoezi',
  language: 'Lugha',
  interfaceLanguage: 'Lugha ya Kiolesura',
  about: 'Kuhusu Mwalimu wa Herufi za NATO',
  question: 'Swali',
  questionCount: '{current} kati ya {total}',
  reviewYourAnswers: 'Pitia Majibu Yako',
  typeNatoWordForLetter: 'Andika neno la NATO kwa herufi {letter}',
  startVoiceInput: 'Anza ingizo la sauti',
  stopVoiceInput: 'Acha ingizo la sauti',
  aboutDescription:
    'Jifunze herufi za sauti za NATO kupitia majaribio ya maingiliano na kurudia kwa nafasi.',
  version: 'Toleo 1.0.0',
  builtWith: 'Imejengwa kwa teknolojia za kisasa za wavuti',
  currentStreak: 'Mfuatano wa Sasa',
  totalSessions: 'Jumla ya Vikao',
  accuracy: 'Usahihi',
  learningProgress: 'Maendeleo ya Kujifunza',
  startQuiz: 'Anza Jaribio',
  restartQuiz: 'Anza Jaribio Upya',
  nextQuestion: 'Swali Linalofuata',
  submitAnswer: 'Wasilisha Jibu',
  showStats: 'Onyesha Takwimu',
  hideStats: 'Ficha Takwimu',
  correctAnswer: 'Jibu Sahihi',
  yourAnswer: 'Jibu Lako',
  correct: 'Sahihi',
  incorrect: 'Sio Sahihi',
  sessionComplete: 'Kikao Kimekamilika!',
  score: 'Alama',
  tryAgain: 'Jaribu Tena',
  hint: 'Kidokezo',
  femaleVoice: 'Sauti ya Kike',
  maleVoice: 'Sauti ya Kiume',
  robotVoice: 'Sauti ya Roboti',
  dailyReminders:
    'Utapokea vikumbusho vya kila siku vya kufanya mazoezi ya herufi za NATO kulingana na maendeleo yako ya kujifunza.',
  speakAnswer: 'Sema jibu lako',
  voiceInputActive: 'Inasikiliza...',
  adaptiveLearning: 'Kujifunza Kinachojipatanisha',
  skipQuestion: 'Ruka',
  pressEnterToSubmit: 'Bonyeza Enter kutuma',
  pressEscapeToSkip: 'Bonyeza Escape kuruka',
  exampleAnswers: 'Mfano: "Alpha", "Bravo", "Charlie"',
  notificationsPanelTitle: 'Arifa',
  markAllAsRead: 'Weka yote kuwa yamesomwa',
  noNotifications: 'Hakuna arifa',
  natoHints: {
    A: 'Herufi ya kwanza ya alfabeti ya Kigiriki',
    B: 'Vizuri, makofi!',
    C: 'C ya sauti, kama jina',
    D: 'Umbo la pembetatu la mto',
    E: 'Mwangwi wa sauti',
    F: 'Ngoma ya ukumbi',
    G: 'Mchezo wa fimbo na mashimo',
    H: 'Mahali pa kulala',
    I: 'Nchi kubwa ya Asia',
    J: 'Bingwa wa Shakespeare',
    K: 'Kipimo cha uzito (gramu 1000)',
    L: 'Mji mkuu wa Peru',
    M: 'Kifupi cha kipaza sauti',
    N: 'Mwezi wa majira ya baridi',
    O: 'Tuzo ya Akademi',
    P: 'Baba, kirafiki',
    Q: 'Jimbo la Canada',
    R: 'Mhusika wa Shakespeare',
    S: 'Mlolongo wa milima',
    T: 'Ngoma ya Argentina',
    U: 'Mavazi sawa kwa wote',
    V: 'Mshindi, bingwa',
    W: 'Kinywaji chenye nguvu',
    X: 'Upigaji picha wa kimatibabu',
    Y: 'Mchezaji wa besiboli wa Marekani',
    Z: 'Taifa la vita la Afrika',
  },
  learning: 'Kujifunza',
  review: 'Kukagua',
  mastered: 'Umejifunza',
  lastFiveTimes: 'Muda wa Jaribio wa Mwisho 5',
  quizTimes: 'Muda wa Jaribio',
  bestTime: 'Muda Bora',
  noTimesRecorded: 'Hakuna Muda Ulioandikwa',
  spacedRepetitionDescription:
    'Kila seti ya maswali 10 hubadilika kulingana na utendaji wako kwa kutumia rudia kwa nafasi.',
  theme: 'Mandhari',
  lightTheme: 'Mwanga',
  darkTheme: 'Giza',
  rainbowTheme: 'Upinde wa mvua',
  systemTheme: 'Mfumo',
  appearance: 'Muonekano',
  chooseTheme: 'Chagua mandhari unayopendelea',
  speechRate: 'Kiwango cha usemi',
  pitch: 'Lami',
  volume: 'Sauti',
  // Custom Word Input
  enterCustomWord: 'Ingiza Neno Maalum',
  enterYourWordOrPhrase: 'Ingiza neno au kifungu chako...',
  useThisWord: 'Tumia Neno Hili',
  // WordDisplay localization
  currentWordLabel: 'Neno la Sasa',
  customWordLabel: 'Maalum',
  currentWordSpeech: 'Neno la sasa ni: {word}',
  difficultyLabels: {
    easy: 'Rahisi',
    medium: 'Wastani',
    hard: 'Gumu',
  },
  categoryLabels: {
    animals: 'Wanyamapori',
    places: 'Maeneo',
    nature: 'Mazingira',
    technology: 'Teknolojia',
    home: 'Nyumbani',
    objects: 'Vitu',
    transport: 'Usafiri',
  },
  // NATO Input specific translations
  natoInputTitle: 'Uingizaji wako wa Alfabeti ya NATO',
  natoInputPlaceholder: 'Ingiza maneno ya NATO: "Alpha Bravo Charlie..."',
  natoInputListening: 'Inasikiliza...',
  natoInputLiveScore: 'Alama za Moja Kwa Moja',

  // Quiz Header translations
  wordQuizInstructions:
    'Badilisha neno hapa chini kuwa alfabeti ya NATO. Sema kila neno la NATO likitenganishwa na nafasi au vikoma.',

  // Quiz Actions translations
  retry: 'Jaribu Tena',
  checkAnswer: 'Angalia Jibu',
  newRandomWord: 'Neno Jipya la Nasibu',
  cancelCustom: 'Ghairi Maalum',
  customWord: 'Neno Maalum',

  // Quiz Results translations
  perfect: 'Kamili!',
  results: 'Matokeo',
  expectedNato: 'NATO Inayotarajiwa:',
  play: 'Cheza',
  letterByLetter: 'Herufi kwa Herufi:',
};
